import { intakeValueToLabel } from "@/src/utils/intakeCalc";

/** Matches PDF Intakes table: September 2026 → 2026/2027; February 2026 → 2025/2026. */
export const resolveIntakeAcademicYearLabel = (intake?: string | null): string => {
  const trimmed = (intake ?? "").trim();
  if (!trimmed) return "2026/2027";

  const slugMatch = trimmed.match(/^(february|september)-(\d{4})$/i);
  if (slugMatch) {
    const month = slugMatch[1].toLowerCase();
    const year = Number(slugMatch[2]);
    if (month === "september") {
      return `${year}/${year + 1}`;
    }
    return `${year - 1}/${year}`;
  }

  const label = intakeValueToLabel(trimmed);
  const labelMatch = label.match(/^(February|September)\s+(\d{4})$/i);
  if (labelMatch) {
    const month = labelMatch[1].toLowerCase();
    const year = Number(labelMatch[2]);
    if (month === "september") {
      return `${year}/${year + 1}`;
    }
    return `${year - 1}/${year}`;
  }

  return trimmed;
};
